export default __webpack_public_path__ + "static/media/landingIcon.0394929a.png";